import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";

function LookupReceiptModal() {
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const paramObject = useParams();
  const [value, setValue] = useState([]);
  const [receiptData, setReceiptData] = useState([]);

  const handleLookupReceiptClick = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/lookupreceipt?receivingid=${value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setReceiptData(res.data.ResponseData);
          navigate(`/receiving-receipt/${value}`);
        } else {
          console.log(res.data.ResponseData); // or display an error message
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <>
      <div
        className="modal fade"
        id="LookupReceiptModal"
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Lookup Receipt</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <input
                    type="number"
                    className="form-control "
                    placeholder="Receiving Id"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-primary btn-md me-1 form-control text-align-center"
                data-bs-dismiss="modal"
                onClick={() => handleLookupReceiptClick(value)}
              >
                Lookup Receipt
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LookupReceiptModal;
